import { render, staticRenderFns } from "./works.vue?vue&type=template&id=65e61901&"
import script from "./works.vue?vue&type=script&lang=js&"
export * from "./works.vue?vue&type=script&lang=js&"
import style0 from "./works.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "works.vue"
export default component.exports